'use client';

/**
 * "Trips you saved": shared trips this device saved with "Save" on a shared
 * trip page. Each row goes back to that page (where "Take this trip" lives).
 * Renders nothing until something is saved.
 */
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { withBase } from '../../lib/brand';
import { readSavedShared, type SavedShared } from './savedShared';

export default function SavedSharedTrips({ className = '' }: { className?: string }) {
  const [list, setList] = useState<SavedShared[]>([]);
  useEffect(() => {
    try {
      setList(readSavedShared(window.localStorage));
    } catch {
      setList([]);
    }
  }, []);
  if (!list.length) return null;
  return (
    <section className={className} aria-labelledby="saved-shared-title" data-testid="saved-shared-trips">
      <h2 id="saved-shared-title" className="m-0 text-tp-sm font-semibold text-tp-ink">
        Trips you saved
      </h2>
      <ul className="m-0 mt-2 list-none divide-y divide-tp-line p-0" style={{ paddingLeft: 0 }}>
        {list.slice(0, 4).map((s) => (
          <li key={s.token}>
            <Link
              href={withBase(`/trip/shared/${s.token}`)}
              className="group flex items-center gap-3 rounded-tp py-2 no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tp-brand/45"
            >
              <span className="block h-10 w-10 flex-none overflow-hidden rounded-tp bg-tp-surface ring-1 ring-inset ring-tp-line">
                {s.cover && (
                  // eslint-disable-next-line @next/next/no-img-element
                  <img src={s.cover} alt="" loading="lazy" className="block h-full w-full object-cover" />
                )}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-tp-base font-semibold text-tp-ink group-hover:underline">{s.name}</span>
                {(s.days || s.km) && (
                  <span className="block text-tp-xs tabular-nums text-tp-muted">
                    {[s.days ? `${s.days} ${s.days === 1 ? 'day' : 'days'}` : null, s.km ? `${Math.round(s.km).toLocaleString('en-AU')} km` : null]
                      .filter(Boolean)
                      .join(' · ')}
                  </span>
                )}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
